import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  HostBinding,
  Input,
} from '@angular/core';
import {
  TopIconCardBodyDirective,
  TopIconCardFooterDirective,
} from './top-icon-card-sections';
import { expansion } from '../../animations';

@Component({
    selector: 'lui-top-icon-card',
    templateUrl: './top-icon-card.component.html',
    styleUrls: ['./top-icon-card.component.scss'],
    animations: [expansion],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TopIconCardComponent {
  @Input() disabled = false;

  @Input() compact = false;

  @Input() loading!: boolean;

  @Input() fillUsing: 'body' | 'footer' = 'body';

  @HostBinding('class.compact') get compactClass() {
    return this.compact;
  }

  @HostBinding('class.lui-top-icon-card-disabled') get disabledClass() {
    return this.disabled;
  }

  @ContentChild(TopIconCardBodyDirective) body!: TopIconCardBodyDirective;
  @ContentChild(TopIconCardFooterDirective) footer!: TopIconCardFooterDirective;
}
